/// <amd-module name="Release/EnvironmentNode/Helpers" />
import { Statuses, IStatusProps } from "VSSUI/Status"

import { ReleaseEnvironment, ApprovalStatus, ReleaseApproval, DeploymentAttempt, DeploymentStatus, DeploymentOperationStatus } from "Release/Client/Contracts/Release";
import { IActiveReleaseEnvironmentNodeProps, ComputedDeploymentStatus } from "./Types";
import { getStatusInfo, getComputedStatus, getLatestDeploymentAttempt, ReleaseEnvironmentStatusIndicator } from "StatusComputer";

export enum ReleaseEnvironmentTileSize {
    Small = 0,
    Large = 1
}

export function getStatusText(environment: ReleaseEnvironment): string {
    const computedStatus = getComputedStatusForEnvironment(environment);
    return getStatusInfo(computedStatus).statusText as string;
}

export function getIconStatusProps(statusIndicator: ReleaseEnvironmentStatusIndicator): IStatusProps {
    const statusInfo = _statusMap[statusIndicator];
    return statusInfo ? statusInfo : Statuses.Queued;
}

export function getBorderColorCssPrefix(environment: ReleaseEnvironment): string {
    const computedStatus = getComputedStatusForEnvironment(environment);
    return getStatusInfo(computedStatus).statusIndicator as string;
}

export function getComputedStatusForEnvironment(environment: ReleaseEnvironment): ComputedDeploymentStatus {
    if (!environment || !environment.deploySteps || environment.deploySteps.length <= 0) {
        return ComputedDeploymentStatus.NotDeployed;
    }

    const latestDeploymentAttempt = getLatestDeploymentAttempt(environment.deploySteps);
    return latestDeploymentAttempt
        ? getComputedStatus(latestDeploymentAttempt.status || DeploymentStatus.Undefined, latestDeploymentAttempt.operationStatus || DeploymentOperationStatus.Undefined)
        : ComputedDeploymentStatus.Undefined;
}

function _initializeStatusMap(): { [key: string]: IStatusProps } {
    let statusMap: { [key: string]: IStatusProps } = {
        [ReleaseEnvironmentStatusIndicator.NotDeployed]: Statuses.Queued,
        [ReleaseEnvironmentStatusIndicator.InProgress]: Statuses.Running,
        [ReleaseEnvironmentStatusIndicator.PreApprovalPending]: Statuses.Waiting,
        [ReleaseEnvironmentStatusIndicator.PostApprovalPending]: Statuses.Waiting,
        [ReleaseEnvironmentStatusIndicator.PreEvaluatingGates]: Statuses.Running,
        [ReleaseEnvironmentStatusIndicator.PostEvaluatingGates]: Statuses.Running,
        [ReleaseEnvironmentStatusIndicator.Succeeded]: Statuses.Success,
        [ReleaseEnvironmentStatusIndicator.Canceled]: Statuses.Canceled,
        [ReleaseEnvironmentStatusIndicator.Canceling]: Statuses.Canceled,
        [ReleaseEnvironmentStatusIndicator.Deferred]: Statuses.Waiting,
        [ReleaseEnvironmentStatusIndicator.Failed]: Statuses.Failed,
        [ReleaseEnvironmentStatusIndicator.Rejected]: Statuses.Failed,
        [ReleaseEnvironmentStatusIndicator.Queued]: Statuses.Queued,
        [ReleaseEnvironmentStatusIndicator.Scheduled]: Statuses.Waiting,
        [ReleaseEnvironmentStatusIndicator.PartiallySucceeded]: Statuses.Warning,
        [ReleaseEnvironmentStatusIndicator.Undefined]: Statuses.Queued,
        [ReleaseEnvironmentStatusIndicator.Pending]: Statuses.Waiting
    };

    return statusMap;
}

const _statusMap: { [key: string]: IStatusProps } = _initializeStatusMap();
